import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconEngineSize = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M20 6H18V5C18 3.9 17.1 3 16 3H10C8.9 3 8 3.9 8 5V6H7C5.89 6 5 6.9 5 8V9H4V7H2V13H4V11H5V12C5 13.1 5.9 14 7 14H7.47L8.88 16.11C9.25 16.67 9.88 17 10.55 17H16.01C17.11 17 18.01 16.1 18.01 15V14H22.01V6H20.01H20ZM20 12H16V15H10.53L8.53 12H6.99V8H9.99V5H15.99V8H19.99V12H20Z" }),
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M21 16L19 18H20V19H4V18H5L3 16L1 18H2V19V20V21H22V20V19V18H23L21 16Z" }))));
};
